import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {
    vasAllGroupByType, vasVaild,
    vasTopup, vasTopupPricing, vasTopupPricingEnable, vasTopupPricingDisable, vasTopupPricingShow, vasTopupPricingHide, vasTopups,
    vasProduct, vasProductPricing, vasProductPricingEnable, vasProductPricingDisable, vasProductPricingShow, vasProductPricingHide, vasProducts,
    vasSvc, vasSvcPricing, vasSvcPricingEnable, vasSvcPricingDisable, vasSvcPricingShow, vasSvcPricingHide, vasSvcs,vasSvcValidity,
    vasMembership, vasMembershipPricing, vasMembershipPricingEnable, vasMembershipPricingDisable, vasMembershipPricingShow, vasMembershipPricingHide,
     vasMemberships, vasMembershipBenefitSave,vasMembershipComputeUpgrade,vasMembershipCreateUpgrade,
    vasSvcsAdmin,vasSvcAdmin
} = api

/**
 * 查找列表
 */
export async function findVasTopups(params) {
    return request({url: vasTopups, method: 'get', data: params,})
}

export async function findVasProducts(params) {
    return request({url: vasProducts, method: 'get', data: params,})
}

export async function findVasSvcs(params) {
    return request({url: vasSvcs, method: 'get', data: params,})
}

export async function findVasMemberships(params) {
    return request({url: vasMemberships, method: 'get', data: params,})
}

export async function findAllVasGroupByType(params) {
    return request({url: vasAllGroupByType, method: 'get', data: params,})
}

export async function vaildVas(params) {
    return request({url: vasVaild, method: 'post', data: params,})
}

export async function findVasSvcsAdmin(params) {
    return request({url: vasSvcsAdmin, method: 'get', data: params,})
}

/**
 * 查找单个
 */
export async function findValidity(params) {
    return request({url: vasSvcValidity, method: 'get', data: params,})
}
export async function findVasTopup(params) {
    return request({url: vasTopup, method: 'get', data: params,})
}

export async function findVasProduct(params) {
    return request({url: vasProduct, method: 'get', data: params,})
}

export async function findVasSvc(params) {
    return request({url: vasSvc, method: 'get', data: params,})
}

export async function findVasMembership(params) {
    return request({url: vasMembership, method: 'get', data: params,})
}


export async function findVasTopupPricing(params) {
    return request({url: vasTopupPricing, method: 'get', data: params,})
}

export async function findVasProductPricing(params) {
    return request({url: vasProductPricing, method: 'get', data: params,})
}

export async function findVasSvcPricing(params) {
    return request({url: vasSvcPricing, method: 'get', data: params,})
}

export async function findVasMembershipPricing(params) {
    return request({url: vasMembershipPricing, method: 'get', data: params,})
}


/**
 * 创建
 */
export async function createVasTopup(params) {
    return request({url: vasTopups, method: 'post', data: params,})
}

export async function createVasProduct(params) {
    return request({url: vasProducts, method: 'post', data: params,})
}

export async function createVasSvc(params) {
    return request({url: vasSvcs, method: 'post', data: params,})
}

export async function createVasMembership(params) {
    return request({url: vasMemberships, method: 'post', data: params,})
}


export async function createVasTopupPricing(params) {
    return request({url: vasTopup, method: 'post', data: params,})
}

export async function createVasProductPricing(params) {
    return request({url: vasProduct, method: 'post', data: params,})
}

export async function createVasSvcPricing(params) {
    return request({url: vasSvc, method: 'post', data: params,})
}

export async function createVasMembershipPricing(params) {
    return request({url: vasMembership, method: 'post', data: params,})
}


/**
 * 更新
 */
export async function updateVasTopup(params) {
    return request({url: vasTopup, method: 'put', data: params,})
}

export async function updateVasProduct(params) {
    return request({url: vasProduct, method: 'put', data: params,})
}

export async function updateVasSvc(params) {
    return request({url: vasSvc, method: 'put', data: params,})
}

export async function updateVasMembership(params) {
    return request({url: vasMembership, method: 'put', data: params,})
}

export async function updateVasTopupPricing(params) {
    return request({url: vasTopupPricing, method: 'put', data: params,})
}

export async function updateVasProductPricing(params) {
    return request({url: vasProductPricing, method: 'put', data: params,})
}

export async function updateVasSvcPricing(params) {
    return request({url: vasSvcPricing, method: 'put', data: params,})
}

export async function updateVasMembershipPricing(params) {
    return request({url: vasMembershipPricing, method: 'put', data: params,})
}

export async function updateVasSvcAdmin(params) {
    return request({url:vasSvcAdmin , method: 'get', data: params,})
}

/**
 * 会员权益
 */
export async function saveVasMembershipBenefits(params) {
    return request({url: vasMembershipBenefitSave, method: 'post', data: params,})
}


/**
 * 启用
 */
export async function enableVasTopupPricing(params) {
    return request({url: vasTopupPricingEnable, method: 'post', data: params,})
}

export async function enableVasProductPricing(params) {
    return request({url: vasProductPricingEnable, method: 'post', data: params,})
}

export async function enableVasSvcPricing(params) {
    return request({url: vasSvcPricingEnable, method: 'post', data: params,})
}

export async function enableVasMembershipPricing(params) {
    return request({url: vasMembershipPricingEnable, method: 'post', data: params,})
}


/**
 * 停用
 */

export async function disableVasTopupPricing(params) {
    return request({url: vasTopupPricingDisable, method: 'post', data: params,})
}

export async function disableVasProductPricing(params) {
    return request({url: vasProductPricingDisable, method: 'post', data: params,})
}

export async function disableVasSvcPricing(params) {
    return request({url: vasSvcPricingDisable, method: 'post', data: params,})
}

export async function disableVasMembershipPricing(params) {
    return request({url: vasMembershipPricingDisable, method: 'post', data: params,})
}


/**
 * 显示
 */
export async function showVasTopupPricing(params) {
    return request({url: vasTopupPricingShow, method: 'post', data: params,})
}

export async function showVasProductPricing(params) {
    return request({url: vasProductPricingShow, method: 'post', data: params,})
}

export async function showVasSvcPricing(params) {
    return request({url: vasSvcPricingShow, method: 'post', data: params,})
}

export async function showVasMembershipPricing(params) {
    return request({url: vasMembershipPricingShow, method: 'post', data: params,})
}


/**
 * 隐藏
 */

export async function hideVasTopupPricing(params) {
    return request({url: vasTopupPricingHide, method: 'post', data: params,})
}

export async function hideVasProductPricing(params) {
    return request({url: vasProductPricingHide, method: 'post', data: params,})
}

export async function hideVasSvcPricing(params) {
    return request({url: vasSvcPricingHide, method: 'post', data: params,})
}

export async function hideVasMembershipPricing(params) {
    return request({url: vasMembershipPricingHide, method: 'post', data: params,})
}


/**
 * 删除
 */
export async function deleteVasTopup(params) {
    return request({url: vasTopup, method: 'delete', data: params,})
}

export async function deleteVasProduct(params) {
    return request({url: vasProduct, method: 'delete', data: params,})
}

export async function deleteVasSvc(params) {
    return request({url: vasSvc, method: 'delete', data: params,})
}

export async function deleteVasMembership(params) {
    return request({url: vasMembership, method: 'delete', data: params,})
}


export async function deleteVasTopupPricing(params) {
    return request({url: vasTopupPricing, method: 'delete', data: params,})
}

export async function deleteVasProductPricing(params) {
    return request({url: vasProductPricing, method: 'delete', data: params,})
}

export async function deleteVasSvcPricing(params) {
    return request({url: vasSvcPricing, method: 'delete', data: params,})
}

export async function deleteVasMembershipPricing(params) {
    return request({url: vasMembershipPricing, method: 'delete', data: params,})
}

/**
 * 升级会员
 */
export async function findVasMembershipComputeUpgrade(params) {
    return request({url: vasMembershipComputeUpgrade, method: 'get', data: params,})
}
export async function createVasMembershipCreateUpgrade(params) {
    return request({url: vasMembershipCreateUpgrade, method: 'post', data: params,})
}









// WEBPACK FOOTER //
// ./src/services/vas.js